import { Box, Button, Typography } from "@mui/material";
import { MdAdd } from "react-icons/md";

export default function AddonsHeader({ handleCreateAddon = () => {} }) {
  return (
    <Box className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
      <Box>
        <Typography variant="h5" className="font-bold text-slate-900">
          Add-ons
        </Typography>
        <Typography variant="body2" className="text-slate-600 mt-1">
          Manage optional subscription add-ons, pricing, billing methods, and
          availability.
        </Typography>
      </Box>

      <Button
        variant="contained"
        startIcon={<MdAdd />}
        onClick={handleCreateAddon}
        className="bg-primary1"
        sx={{
          alignSelf: { xs: "flex-start", md: "center" },
          textTransform: "none",
          px: 3,
          py: 1.25,
          borderRadius: "12px",
          fontWeight: 600,
          "&:hover": {
            bgcolor: "inherit",
          },
        }}
      >
        Add Add-on
      </Button>
    </Box>
  );
}
